const Redirect = () => import('@/pages/Redirect.vue')
const Settings = () => import('@/pages/Settings.vue')
const SettingsSecurity = () => import('@/pages/settings/Security.vue')
const SettingsPrivacy = () => import('@/pages/settings/Privacy.vue')
const SettingsContent = () => import('@/pages/settings/Content.vue')
const SettingsApp = () => import('@/pages/settings/App.vue')
const SettingsSkills = () => import('@/pages/settings/Skills.vue')
const SettingsDocuments = () => import('@/pages/settings/Documents.vue')
const SettingsTools = () => import('@/pages/settings/Tools.vue')

export default [
    {
        path: '/reglages',
        name: 'settings',
        component: Settings,
        redirect: (/*to*/) => {
            return {name: 'settings-index'}
        },
        meta: {
            guard: 'auth',
        },

        children: [
            {
                path: '',
                name: 'settings-index',
                component: Redirect,
                redirect: (/*to*/) => {
                    return {name: 'settings-security'}
                },
                meta: {
                    title: 'Réglages',
                    guard: 'auth',
                },
            },
            {
                path: 'securite',
                name: 'settings-security',
                component: SettingsSecurity,
                meta: {
                    title: 'Réglages - Sécurité',
                    guard: 'auth',
                },
            },
            {
                path: 'confidentialite',
                name: 'settings-privacy',
                component: SettingsPrivacy,
                meta: {
                    title: 'Réglages - Confidentialité',
                    guard: 'auth',
                },
            },
            {
                path: 'contenus',
                name: 'settings-content',
                component: SettingsContent,
                meta: {
                    title: 'Réglages - Contenus',
                    guard: 'auth',
                },
            },
            {
                path: 'app',
                name: 'settings-app',
                component: SettingsApp,
                meta: {
                    title: 'Réglages - Application',
                    guard: 'auth',
                },
            },
            {
                path: 'skills',
                name: 'settings-skills',
                component: SettingsSkills,
                meta: {
                    title: 'Réglages - Compétences',
                    guard: 'auth',
                },
            },
            {
                path: 'documents',
                name: 'settings-documents',
                component: SettingsDocuments,
                meta: {
                    title: 'Réglages - Compétences',
                    guard: 'auth',
                },
            },
            {
                path: 'outils',
                name: 'settings-tools',
                component: SettingsTools,
                meta: {
                    title: 'Réglages - Outils',
                    guard: 'auth',
                },
            },
        ],

    },
]
